/* THIS IS A GENERATED FILE. PLEASE DO NOT MODIFY!! */
import * as Types from '../../../../types/dashboard-core-gqlTypes.generated.d';

import { BankAccountWithInstitutionAndOwnerFragmentGQLType } from '../../bankAccounts/requests/bankAccounts.gql.generated';
import { gql } from '@apollo/client';
import { BankAccountWithInstitutionAndOwnerFragmentDocGQLType } from '../../bankAccounts/requests/bankAccounts.gql.generated';
import * as Apollo from '@apollo/client';
const defaultOptions =  {}
export type InvoiceItemFragmentGQLType = (
  { __typename?: 'InvoiceItem' }
  & Pick<Types.InvoiceItemGQLType, 'id' | 'invoiceId' | 'accountingAccountId' | 'amount' | 'status' | 'capitalizedLoanId' | 'finleyAccruedAmount' | 'created_at' | 'updated_at'>
  & { accountingAccount: (
    { __typename?: 'TAccount' }
    & Pick<Types.TAccountGQLType, 'id' | 'tAccount' | 'creditFacilityId' | 'organizationId'>
  ) }
);

export type InvoiceComponentWithInvoiceItemsFragmentGQLType = (
  { __typename?: 'InvoiceComponentWithInvoiceItems' }
  & { invoiceComponent: (
    { __typename?: 'InvoiceComponent' }
    & Pick<Types.InvoiceComponentGQLType, 'id' | 'invoiceId' | 'finleyLoanId' | 'invoiceComponentType' | 'totalAmount' | 'accrualStartDate' | 'accrualEndDate' | 'created_at' | 'updated_at'>
  ), invoiceItems: Array<(
    { __typename?: 'InvoiceItem' }
    & InvoiceItemFragmentGQLType
  )> }
);

export type InvoiceReportFragmentGQLType = (
  { __typename?: 'InvoiceReport' }
  & Pick<Types.InvoiceReportGQLType, 'id' | 'reportType' | 'reportName' | 'reportingDate' | 'version' | 'isPreview' | 'capitalProviderId' | 'capitalProviderName' | 'invoiceId' | 'paymentInKindItemId'>
);

export type InvoiceDisbursementItemDifferenceFragmentGQLType = (
  { __typename?: 'InvoiceDisbursementItemDifference' }
  & Pick<Types.InvoiceDisbursementItemDifferenceGQLType, 'capitalProviderId' | 'capitalProviderName' | 'tAccountType' | 'inputAmount' | 'finleyAmount' | 'difference' | 'inputProRataShare' | 'finleyProRataShare'>
);

export type InvoiceCalculationComparisonFragmentGQLType = (
  { __typename?: 'InvoiceCalculationComparison' }
  & Pick<Types.InvoiceCalculationComparisonGQLType, 'loanId' | 'loanName' | 'externalLoanId'>
  & { invoiceComponentDifferences: Array<(
    { __typename?: 'InvoiceComponentDifference' }
    & Pick<Types.InvoiceComponentDifferenceGQLType, 'inputAmount' | 'finleyAmount' | 'difference'>
  )>, invoiceDisbursementItemDifferences: (
    { __typename?: 'InvoiceDisbursementItemDifferences' }
    & { interest: Array<(
      { __typename?: 'InvoiceDisbursementItemDifference' }
      & InvoiceDisbursementItemDifferenceFragmentGQLType
    )>, principal: Array<(
      { __typename?: 'InvoiceDisbursementItemDifference' }
      & InvoiceDisbursementItemDifferenceFragmentGQLType
    )> }
  ) }
);

export type InvoiceFragmentGQLType = (
  { __typename?: 'Invoice' }
  & Pick<Types.InvoiceGQLType, 'id' | 'creditFacilityId' | 'originatingInvoiceId' | 'paymentSourceOrganizationId' | 'paymentDestinationOrganizationId' | 'sourceBankAccountId' | 'destinationBankAccountId' | 'status' | 'totalAmount' | 'autoSettle' | 'memo' | 'createdByType' | 'targetInvoiceDate' | 'dueDate' | 'paymentDate' | 'created_at' | 'updated_at'>
  & { invoiceComponentsWithInvoiceItems: Array<(
    { __typename?: 'InvoiceComponentWithInvoiceItems' }
    & InvoiceComponentWithInvoiceItemsFragmentGQLType
  )>, creditFacility: (
    { __typename?: 'CreditFacility' }
    & Pick<Types.CreditFacilityGQLType, 'id' | 'name' | 'externalFacilityId'>
  ), paymentSourceOrganization: (
    { __typename?: 'EntityIdAndName' }
    & Pick<Types.EntityIdAndNameGQLType, 'id' | 'name'>
  ), paymentDestinationOrganization: (
    { __typename?: 'EntityIdAndName' }
    & Pick<Types.EntityIdAndNameGQLType, 'id' | 'name'>
  ), destinationBankAccount?: Types.Maybe<(
    { __typename?: 'BankAccountWithInstitutionAndOwner' }
    & BankAccountWithInstitutionAndOwnerFragmentGQLType
  )>, invoiceReports?: Types.Maybe<Array<(
    { __typename?: 'InvoiceReport' }
    & Pick<Types.InvoiceReportGQLType, 'id' | 'reportType' | 'reportName' | 'reportingDate' | 'version' | 'isPreview' | 'capitalProviderId' | 'capitalProviderName' | 'invoiceId' | 'paymentInKindItemId'>
  )>>, invoiceCalculationComparisons: Array<(
    { __typename?: 'InvoiceCalculationComparison' }
    & InvoiceCalculationComparisonFragmentGQLType
  )> }
);

export type InvoiceSummaryFragmentGQLType = (
  { __typename?: 'Invoice' }
  & Pick<Types.InvoiceGQLType, 'id' | 'creditFacilityId' | 'originatingInvoiceId' | 'paymentSourceOrganizationId' | 'paymentDestinationOrganizationId' | 'sourceBankAccountId' | 'destinationBankAccountId' | 'status' | 'totalAmount' | 'autoSettle' | 'memo' | 'createdByType' | 'targetInvoiceDate' | 'dueDate' | 'paymentDate' | 'created_at' | 'updated_at'>
  & { invoiceComponentsWithInvoiceItems: Array<(
    { __typename?: 'InvoiceComponentWithInvoiceItems' }
    & InvoiceComponentWithInvoiceItemsFragmentGQLType
  )>, creditFacility: (
    { __typename?: 'CreditFacility' }
    & Pick<Types.CreditFacilityGQLType, 'id' | 'name' | 'externalFacilityId'>
  ), invoiceReports?: Types.Maybe<Array<(
    { __typename?: 'InvoiceReport' }
    & InvoiceReportFragmentGQLType
  )>>, invoiceCalculationComparisons: Array<(
    { __typename?: 'InvoiceCalculationComparison' }
    & InvoiceCalculationComparisonFragmentGQLType
  )> }
);

export type InvoiceListItemFragmentGQLType = (
  { __typename?: 'Invoice' }
  & Pick<Types.InvoiceGQLType, 'id' | 'creditFacilityId' | 'originatingInvoiceId' | 'paymentSourceOrganizationId' | 'paymentDestinationOrganizationId' | 'status' | 'totalAmount' | 'autoSettle' | 'memo' | 'createdByType' | 'targetInvoiceDate' | 'dueDate' | 'paymentDate' | 'created_at' | 'updated_at'>
  & { invoiceComponentsWithInvoiceItems: Array<(
    { __typename?: 'InvoiceComponentWithInvoiceItems' }
    & { invoiceComponent: (
      { __typename?: 'InvoiceComponent' }
      & Pick<Types.InvoiceComponentGQLType, 'id' | 'invoiceId' | 'finleyLoanId' | 'invoiceComponentType' | 'totalAmount' | 'accrualStartDate' | 'accrualEndDate' | 'created_at' | 'updated_at'>
    ), invoiceItems: Array<(
      { __typename?: 'InvoiceItem' }
      & Pick<Types.InvoiceItemGQLType, 'id' | 'invoiceId' | 'accountingAccountId' | 'amount' | 'status' | 'capitalizedLoanId' | 'finleyAccruedAmount' | 'created_at' | 'updated_at'>
      & { accountingAccount: (
        { __typename?: 'TAccount' }
        & Pick<Types.TAccountGQLType, 'id' | 'tAccount' | 'creditFacilityId' | 'organizationId'>
      ) }
    )> }
  )>, creditFacility: (
    { __typename?: 'CreditFacility' }
    & Pick<Types.CreditFacilityGQLType, 'id' | 'name'>
  ) }
);

export type InvoiceDisbursementItemFragmentGQLType = (
  { __typename?: 'InvoiceDisbursementItem' }
  & Pick<Types.InvoiceDisbursementItemGQLType, 'id' | 'invoiceDisbursementId' | 'accountingAccountId' | 'accountingTransactionId' | 'amount' | 'serviceFeeAmount' | 'postServiceFeeTotalAmount' | 'created_at' | 'updated_at'>
  & { accountingAccount: (
    { __typename?: 'TAccount' }
    & Pick<Types.TAccountGQLType, 'id' | 'tAccount' | 'creditFacilityId' | 'organizationId'>
  ) }
);

export type InvoiceDisbursementFragmentGQLType = (
  { __typename?: 'InvoiceDisbursement' }
  & Pick<Types.InvoiceDisbursementGQLType, 'id' | 'invoiceId' | 'invoiceComponentId' | 'capitalProviderOrganizationId' | 'totalAmount' | 'autoSettle' | 'status' | 'dueDate' | 'paymentDate' | 'created_at' | 'updated_at' | 'capitalProviderProRata'>
  & { invoiceDisbursementItems: Array<(
    { __typename?: 'InvoiceDisbursementItem' }
    & InvoiceDisbursementItemFragmentGQLType
  )>, capitalProviderOrganization: (
    { __typename?: 'EntityIdAndName' }
    & Pick<Types.EntityIdAndNameGQLType, 'id' | 'name'>
  ), serviceFeeTotals?: Types.Maybe<(
    { __typename?: 'InvoiceDisbursementServiceFeeTotals' }
    & Pick<Types.InvoiceDisbursementServiceFeeTotalsGQLType, 'serviceFeeAmount' | 'postServiceFeeTotalAmount'>
  )> }
);

export type InvoicePaymentInKindItemFragmentGQLType = (
  { __typename?: 'InvoicePaymentInKindItem' }
  & Pick<Types.InvoicePaymentInKindItemGQLType, 'id' | 'invoiceId' | 'invoiceItemId' | 'capitalizedLenderShareId' | 'capitalizedLoanId' | 'totalAmount' | 'serviceFeeAmount' | 'postServiceFeeTotalAmount' | 'status' | 'dueDate' | 'notifiedDate' | 'created_at' | 'updated_at' | 'capitalProviderProRata'>
  & { capitalProviderOrganization: (
    { __typename?: 'EntityIdAndName' }
    & Pick<Types.EntityIdAndNameGQLType, 'id' | 'name'>
  ) }
);

export type InvoiceConsolidatedDisbursementFragmentGQLType = (
  { __typename?: 'InvoiceConsolidatedDisbursement' }
  & Pick<Types.InvoiceConsolidatedDisbursementGQLType, 'id' | 'invoiceId' | 'capitalProviderOrganizationId' | 'totalCashDisbursementAmount' | 'totalCashServiceFeeAmount' | 'totalPostServiceFeeCashDisbursementAmount' | 'totalInterestCapitalizationAmount' | 'totalInterestCapitalizationServiceFeeAmount' | 'totalPostServiceFeeInterestCapitalizationAmount' | 'status' | 'paymentDate' | 'created_at' | 'updated_at' | 'capitalProviderProRataForFacility'>
  & { capitalProviderOrganization: (
    { __typename?: 'EntityIdAndName' }
    & Pick<Types.EntityIdAndNameGQLType, 'id' | 'name'>
  ) }
);

export type GetInvoicesByOrganizationIdQueryVariablesGQLType = Types.Exact<{
  organizationId: Types.Scalars['UUID'];
}>;


export type GetInvoicesByOrganizationIdQueryGQLType = (
  { __typename?: 'Query' }
  & { getInvoicesByOrganizationId: Array<(
    { __typename?: 'Invoice' }
    & InvoiceListItemFragmentGQLType
  )> }
);

export type GetInvoicesByOrganizationIdPaginatedQueryVariablesGQLType = Types.Exact<{
  organizationId: Types.Scalars['UUID'];
  pagination: Types.InvoicesPaginationInputGQLType;
  creditFacilityIds?: Types.Maybe<Array<Types.Scalars['UUID']> | Types.Scalars['UUID']>;
  startDate?: Types.Maybe<Types.Scalars['FullDateStr']>;
  endDate?: Types.Maybe<Types.Scalars['FullDateStr']>;
  sortBy?: Types.Maybe<Types.InvoiceSortFieldGQLType>;
  sortDirection?: Types.Maybe<Types.SortDirectionGQLType>;
}>;


export type GetInvoicesByOrganizationIdPaginatedQueryGQLType = (
  { __typename?: 'Query' }
  & { getInvoicesByOrganizationIdPaginated: (
    { __typename?: 'InvoicesConnection' }
    & Pick<Types.InvoicesConnectionGQLType, 'totalCount'>
    & { nodes: Array<(
      { __typename?: 'Invoice' }
      & InvoiceListItemFragmentGQLType
    )>, pageInfo: (
      { __typename?: 'PageInfo' }
      & Pick<Types.PageInfoGQLType, 'hasNextPage' | 'hasPreviousPage' | 'startCursor' | 'endCursor'>
    ) }
  ) }
);

export type GetInvoiceAggregatesByOrganizationIdQueryVariablesGQLType = Types.Exact<{
  organizationId: Types.Scalars['UUID'];
  startDate?: Types.Maybe<Types.Scalars['FullDateStr']>;
  endDate?: Types.Maybe<Types.Scalars['FullDateStr']>;
  creditFacilityIds?: Types.Maybe<Array<Types.Scalars['UUID']> | Types.Scalars['UUID']>;
}>;


export type GetInvoiceAggregatesByOrganizationIdQueryGQLType = (
  { __typename?: 'Query' }
  & { getInvoiceAggregatesByOrganizationId: (
    { __typename?: 'InvoiceAggregates' }
    & Pick<Types.InvoiceAggregatesGQLType, 'totalCount'>
    & { dueSoon: (
      { __typename?: 'InvoiceStatusAggregate' }
      & Pick<Types.InvoiceStatusAggregateGQLType, 'status' | 'totalAmount' | 'count'>
    ), overdue: (
      { __typename?: 'InvoiceStatusAggregate' }
      & Pick<Types.InvoiceStatusAggregateGQLType, 'status' | 'totalAmount' | 'count'>
    ), paid: (
      { __typename?: 'InvoiceStatusAggregate' }
      & Pick<Types.InvoiceStatusAggregateGQLType, 'status' | 'totalAmount' | 'count'>
    ) }
  ) }
);

export type GetInvoicesByLoanIdQueryVariablesGQLType = Types.Exact<{
  loanId: Types.Scalars['UUID'];
}>;


export type GetInvoicesByLoanIdQueryGQLType = (
  { __typename?: 'Query' }
  & { invoices: Array<(
    { __typename?: 'Invoice' }
    & InvoiceSummaryFragmentGQLType
  )> }
);

export type GetInvoiceByIdQueryVariablesGQLType = Types.Exact<{
  invoiceId: Types.Scalars['UUID'];
}>;


export type GetInvoiceByIdQueryGQLType = (
  { __typename?: 'Query' }
  & { getInvoiceById: (
    { __typename?: 'Invoice' }
    & InvoiceFragmentGQLType
  ) }
);

export type GetInvoiceDisbursementsByInvoiceIdQueryVariablesGQLType = Types.Exact<{
  invoiceId: Types.Scalars['UUID'];
}>;


export type GetInvoiceDisbursementsByInvoiceIdQueryGQLType = (
  { __typename?: 'Query' }
  & { getInvoiceDisbursementsByInvoiceId: Array<(
    { __typename?: 'InvoiceDisbursement' }
    & InvoiceDisbursementFragmentGQLType
  )> }
);

export type GetInvoiceDisbursementByIdQueryVariablesGQLType = Types.Exact<{
  invoiceDisbursementId: Types.Scalars['UUID'];
}>;


export type GetInvoiceDisbursementByIdQueryGQLType = (
  { __typename?: 'Query' }
  & { getInvoiceDisbursementById: (
    { __typename?: 'InvoiceDisbursement' }
    & InvoiceDisbursementFragmentGQLType
  ) }
);

export type GetInvoicePaymentInKindItemsByInvoiceIdQueryVariablesGQLType = Types.Exact<{
  invoiceId: Types.Scalars['UUID'];
}>;


export type GetInvoicePaymentInKindItemsByInvoiceIdQueryGQLType = (
  { __typename?: 'Query' }
  & { getInvoicePaymentInKindItemsByInvoiceId: Array<(
    { __typename?: 'InvoicePaymentInKindItemsWithMetadata' }
    & Pick<Types.InvoicePaymentInKindItemsWithMetadataGQLType, 'invoiceItemId' | 'capitalizedLoanId' | 'capitalizedLoanName'>
    & { invoicePaymentInKindItems: Array<(
      { __typename?: 'InvoicePaymentInKindItem' }
      & InvoicePaymentInKindItemFragmentGQLType
    )> }
  )> }
);

export type GetInvoicePaymentInKindItemByIdQueryVariablesGQLType = Types.Exact<{
  invoicePaymentInKindItemId: Types.Scalars['UUID'];
}>;


export type GetInvoicePaymentInKindItemByIdQueryGQLType = (
  { __typename?: 'Query' }
  & { getInvoicePaymentInKindItemById: (
    { __typename?: 'InvoicePaymentInKindItem' }
    & InvoicePaymentInKindItemFragmentGQLType
  ) }
);

export type GetInvoiceConsolidatedDisbursementsByInvoiceIdQueryVariablesGQLType = Types.Exact<{
  invoiceId: Types.Scalars['UUID'];
}>;


export type GetInvoiceConsolidatedDisbursementsByInvoiceIdQueryGQLType = (
  { __typename?: 'Query' }
  & { getInvoiceConsolidatedDisbursementsByInvoiceId: Array<(
    { __typename?: 'InvoiceConsolidatedDisbursement' }
    & InvoiceConsolidatedDisbursementFragmentGQLType
  )> }
);

export type GetLatestInvoiceFacilityFeeAccrualEndDateQueryVariablesGQLType = Types.Exact<{
  creditFacilityId: Types.Scalars['UUID'];
}>;


export type GetLatestInvoiceFacilityFeeAccrualEndDateQueryGQLType = (
  { __typename?: 'Query' }
  & Pick<Types.QueryGQLType, 'getLatestInvoiceFacilityFeeAccrualEndDate'>
);

export type GetInvoiceConsolidatedDisbursementByIdQueryVariablesGQLType = Types.Exact<{
  invoiceConsolidatedDisbursementId: Types.Scalars['UUID'];
}>;


export type GetInvoiceConsolidatedDisbursementByIdQueryGQLType = (
  { __typename?: 'Query' }
  & { getInvoiceConsolidatedDisbursementById: (
    { __typename?: 'InvoiceConsolidatedDisbursement' }
    & InvoiceConsolidatedDisbursementFragmentGQLType
  ) }
);

export type GetInvoiceFacilityFeeBalancesQueryVariablesGQLType = Types.Exact<{
  creditFacilityId: Types.Scalars['UUID'];
  startDate: Types.Scalars['FullDateStr'];
  endDate: Types.Scalars['FullDateStr'];
}>;


export type GetInvoiceFacilityFeeBalancesQueryGQLType = (
  { __typename?: 'Query' }
  & { getInvoiceFacilityFeeBalances: Array<(
    { __typename?: 'CreditFacilityAccrualObject' }
    & Pick<Types.CreditFacilityAccrualObjectGQLType, 'totalAccruedAmount'>
    & { account: (
      { __typename?: 'TAccount' }
      & Pick<Types.TAccountGQLType, 'id' | 'tAccount' | 'creditFacilityId' | 'organizationId'>
    ) }
  )> }
);

export type GetPrincipalPaymentMetricsByLoanIdQueryVariablesGQLType = Types.Exact<{
  loanId: Types.Scalars['UUID'];
}>;


export type GetPrincipalPaymentMetricsByLoanIdQueryGQLType = (
  { __typename?: 'Query' }
  & { result: (
    { __typename?: 'PrincipalPaymentMetrics' }
    & Pick<Types.PrincipalPaymentMetricsGQLType, 'latestPaymentDate' | 'loanHasPayment'>
  ) }
);

export type GetLoanMetricsForInvoiceIdQueryVariablesGQLType = Types.Exact<{
  invoiceId: Types.Scalars['UUID'];
}>;


export type GetLoanMetricsForInvoiceIdQueryGQLType = (
  { __typename?: 'Query' }
  & { result: (
    { __typename?: 'LoanMetricsForInvoice' }
    & Pick<Types.LoanMetricsForInvoiceGQLType, 'latestFundTransferDate' | 'hasPrincipalPayment'>
  ) }
);

export type GetPaymentInKindServicingFeeDetailsForCreditFacilitiesQueryVariablesGQLType = Types.Exact<{
  creditFacilityIds: Array<Types.Scalars['UUID']> | Types.Scalars['UUID'];
  invoicePaymentStartDate: Types.Scalars['FullDateStr'];
  invoicePaymentEndDate: Types.Scalars['FullDateStr'];
  capitalizedLoanIds?: Types.Maybe<Array<Types.Scalars['UUID']> | Types.Scalars['UUID']>;
  capitalProviderOrganizationIds?: Types.Maybe<Array<Types.Scalars['UUID']> | Types.Scalars['UUID']>;
}>;


export type GetPaymentInKindServicingFeeDetailsForCreditFacilitiesQueryGQLType = (
  { __typename?: 'Query' }
  & { servicingFeeDetails: Array<(
    { __typename?: 'PaymentInKindServicingFeeDetails' }
    & Pick<Types.PaymentInKindServicingFeeDetailsGQLType, 'creditFacilityId' | 'creditFacilityName' | 'capitalProviderId' | 'capitalProviderName' | 'capitalizedLoanId' | 'capitalizedLoanName' | 'capitalizedExternalLoanId' | 'originatingLoanId' | 'originatingLoanName' | 'originatingExternalLoanId' | 'serviceFeeAmount' | 'invoicePaymentDate' | 'invoiceUpdatedAt' | 'runningBalance'>
    & { report?: Types.Maybe<(
      { __typename?: 'InvoiceReport' }
      & InvoiceReportFragmentGQLType
    )> }
  )> }
);

export type CreateInvoiceWithInvoiceItemsMutationVariablesGQLType = Types.Exact<{
  invoice: Types.InvoiceInputGQLType;
  invoiceComponentsWithInvoiceItems: Array<Types.InvoiceComponentWithInvoiceItemsInputGQLType> | Types.InvoiceComponentWithInvoiceItemsInputGQLType;
}>;


export type CreateInvoiceWithInvoiceItemsMutationGQLType = (
  { __typename?: 'Mutation' }
  & { createInvoiceWithInvoiceItems: (
    { __typename?: 'CreateInvoiceResponse' }
    & Pick<Types.CreateInvoiceResponseGQLType, 'invoiceId' | 'invoiceWorkleaseId' | 'disbursementWorkleaseIds'>
  ) }
);

export type MarkInvoiceAsPaidMutationVariablesGQLType = Types.Exact<{
  invoiceId: Types.Scalars['UUID'];
  invoicePaymentDate: Types.Scalars['FullDateStr'];
}>;


export type MarkInvoiceAsPaidMutationGQLType = (
  { __typename?: 'Mutation' }
  & { markInvoiceAsPaid: (
    { __typename?: 'MarkInvoiceAsPaidResponse' }
    & Pick<Types.MarkInvoiceAsPaidResponseGQLType, 'invoiceId'>
  ) }
);

export type MarkInvoiceAsCanceledMutationVariablesGQLType = Types.Exact<{
  invoiceId: Types.Scalars['UUID'];
}>;


export type MarkInvoiceAsCanceledMutationGQLType = (
  { __typename?: 'Mutation' }
  & { markInvoiceAsCanceled?: Types.Maybe<(
    { __typename?: 'InvoiceIdResponse' }
    & Pick<Types.InvoiceIdResponseGQLType, 'invoiceId'>
  )> }
);

export type MarkInvoiceDisbursementAsPaidMutationVariablesGQLType = Types.Exact<{
  invoiceDisbursementId: Types.Scalars['UUID'];
  disbursementDate: Types.Scalars['FullDateStr'];
}>;


export type MarkInvoiceDisbursementAsPaidMutationGQLType = (
  { __typename?: 'Mutation' }
  & { markInvoiceDisbursementAsPaid: (
    { __typename?: 'MarkInvoiceDisbursementAsPaidResponse' }
    & Pick<Types.MarkInvoiceDisbursementAsPaidResponseGQLType, 'invoiceDisbursementId'>
  ) }
);

export type MarkInvoicePaymentInKindItemAsNotifiedMutationVariablesGQLType = Types.Exact<{
  invoicePaymentInKindItemId: Types.Scalars['UUID'];
  notifiedDate: Types.Scalars['FullDateStr'];
}>;


export type MarkInvoicePaymentInKindItemAsNotifiedMutationGQLType = (
  { __typename?: 'Mutation' }
  & { markInvoicePaymentInKindItemAsNotified: (
    { __typename?: 'MarkInvoicePaymentInKindItemAsNotifiedResponse' }
    & Pick<Types.MarkInvoicePaymentInKindItemAsNotifiedResponseGQLType, 'invoicePaymentInKindItemId'>
  ) }
);

export type UpdateInvoiceDueDateMutationVariablesGQLType = Types.Exact<{
  invoiceId: Types.Scalars['UUID'];
  newDueDate: Types.Scalars['FullDateStr'];
}>;


export type UpdateInvoiceDueDateMutationGQLType = (
  { __typename?: 'Mutation' }
  & { updateInvoiceDueDate?: Types.Maybe<(
    { __typename?: 'UpdateInvoiceResponse' }
    & Pick<Types.UpdateInvoiceResponseGQLType, 'invoiceId'>
  )> }
);

export type ReverseInvoicePaymentMutationVariablesGQLType = Types.Exact<{
  invoiceId: Types.Scalars['UUID'];
}>;


export type ReverseInvoicePaymentMutationGQLType = (
  { __typename?: 'Mutation' }
  & { reverseInvoicePayment?: Types.Maybe<(
    { __typename?: 'UpdateInvoiceResponse' }
    & Pick<Types.UpdateInvoiceResponseGQLType, 'invoiceId'>
  )> }
);

export type MarkInvoiceConsolidatedDisbursementAsPaidMutationVariablesGQLType = Types.Exact<{
  invoiceConsolidatedDisbursementId: Types.Scalars['UUID'];
  paymentDate: Types.Scalars['FullDateStr'];
}>;


export type MarkInvoiceConsolidatedDisbursementAsPaidMutationGQLType = (
  { __typename?: 'Mutation' }
  & { markInvoiceConsolidatedDisbursementAsPaid: (
    { __typename?: 'MarkInvoiceConsolidatedDisbursementAsPaidResponse' }
    & Pick<Types.MarkInvoiceConsolidatedDisbursementAsPaidResponseGQLType, 'invoiceConsolidatedDisbursementId'>
  ) }
);

export type UndoMarkInvoiceConsolidatedDisbursementAsPaidMutationVariablesGQLType = Types.Exact<{
  invoiceConsolidatedDisbursementId: Types.Scalars['UUID'];
}>;


export type UndoMarkInvoiceConsolidatedDisbursementAsPaidMutationGQLType = (
  { __typename?: 'Mutation' }
  & { undoMarkInvoiceConsolidatedDisbursementAsPaid: (
    { __typename?: 'MarkInvoiceConsolidatedDisbursementAsPaidResponse' }
    & Pick<Types.MarkInvoiceConsolidatedDisbursementAsPaidResponseGQLType, 'invoiceConsolidatedDisbursementId'>
  ) }
);

export const InvoiceItemFragmentDocGQLType = gql`
    fragment InvoiceItem on InvoiceItem {
  id
  invoiceId
  accountingAccountId
  amount
  status
  capitalizedLoanId
  finleyAccruedAmount
  created_at
  updated_at
  accountingAccount {
    id
    tAccount
    creditFacilityId
    organizationId
  }
}
    `;
export const InvoiceComponentWithInvoiceItemsFragmentDocGQLType = gql`
    fragment InvoiceComponentWithInvoiceItems on InvoiceComponentWithInvoiceItems {
  invoiceComponent {
    id
    invoiceId
    finleyLoanId
    invoiceComponentType
    totalAmount
    accrualStartDate
    accrualEndDate
    created_at
    updated_at
  }
  invoiceItems {
    ...InvoiceItem
  }
}
    ${InvoiceItemFragmentDocGQLType}`;
export const InvoiceDisbursementItemDifferenceFragmentDocGQLType = gql`
    fragment InvoiceDisbursementItemDifference on InvoiceDisbursementItemDifference {
  capitalProviderId
  capitalProviderName
  tAccountType
  inputAmount
  finleyAmount
  difference
  inputProRataShare
  finleyProRataShare
}
    `;
export const InvoiceCalculationComparisonFragmentDocGQLType = gql`
    fragment InvoiceCalculationComparison on InvoiceCalculationComparison {
  loanId
  loanName
  externalLoanId
  invoiceComponentDifferences {
    inputAmount
    finleyAmount
    difference
  }
  invoiceDisbursementItemDifferences {
    interest {
      ...InvoiceDisbursementItemDifference
    }
    principal {
      ...InvoiceDisbursementItemDifference
    }
  }
}
    ${InvoiceDisbursementItemDifferenceFragmentDocGQLType}`;
export const InvoiceFragmentDocGQLType = gql`
    fragment Invoice on Invoice {
  id
  creditFacilityId
  originatingInvoiceId
  paymentSourceOrganizationId
  paymentDestinationOrganizationId
  sourceBankAccountId
  destinationBankAccountId
  status
  totalAmount
  autoSettle
  memo
  createdByType
  targetInvoiceDate
  dueDate
  paymentDate
  created_at
  updated_at
  invoiceComponentsWithInvoiceItems {
    ...InvoiceComponentWithInvoiceItems
  }
  creditFacility {
    id
    name
    externalFacilityId
  }
  paymentSourceOrganization {
    id
    name
  }
  paymentDestinationOrganization {
    id
    name
  }
  destinationBankAccount {
    ...BankAccountWithInstitutionAndOwner
  }
  invoiceReports {
    id
    reportType
    reportName
    reportingDate
    version
    isPreview
    capitalProviderId
    capitalProviderName
    invoiceId
    paymentInKindItemId
  }
  invoiceCalculationComparisons {
    ...InvoiceCalculationComparison
  }
}
    ${InvoiceComponentWithInvoiceItemsFragmentDocGQLType}
${BankAccountWithInstitutionAndOwnerFragmentDocGQLType}
${InvoiceCalculationComparisonFragmentDocGQLType}`;
export const InvoiceReportFragmentDocGQLType = gql`
    fragment InvoiceReport on InvoiceReport {
  id
  reportType
  reportName
  reportingDate
  version
  isPreview
  capitalProviderId
  capitalProviderName
  invoiceId
  paymentInKindItemId
}
    `;
export const InvoiceSummaryFragmentDocGQLType = gql`
    fragment InvoiceSummary on Invoice {
  id
  creditFacilityId
  originatingInvoiceId
  paymentSourceOrganizationId
  paymentDestinationOrganizationId
  sourceBankAccountId
  destinationBankAccountId
  status
  totalAmount
  autoSettle
  memo
  createdByType
  targetInvoiceDate
  dueDate
  paymentDate
  created_at
  updated_at
  invoiceComponentsWithInvoiceItems {
    ...InvoiceComponentWithInvoiceItems
  }
  creditFacility {
    id
    name
    externalFacilityId
  }
  invoiceReports {
    ...InvoiceReport
  }
  invoiceCalculationComparisons {
    ...InvoiceCalculationComparison
  }
}
    ${InvoiceComponentWithInvoiceItemsFragmentDocGQLType}
${InvoiceReportFragmentDocGQLType}
${InvoiceCalculationComparisonFragmentDocGQLType}`;
export const InvoiceListItemFragmentDocGQLType = gql`
    fragment InvoiceListItem on Invoice {
  id
  creditFacilityId
  originatingInvoiceId
  paymentSourceOrganizationId
  paymentDestinationOrganizationId
  status
  totalAmount
  autoSettle
  memo
  createdByType
  targetInvoiceDate
  dueDate
  paymentDate
  created_at
  updated_at
  invoiceComponentsWithInvoiceItems {
    invoiceComponent {
      id
      invoiceId
      finleyLoanId
      invoiceComponentType
      totalAmount
      accrualStartDate
      accrualEndDate
      created_at
      updated_at
    }
    invoiceItems {
      id
      invoiceId
      accountingAccountId
      amount
      status
      capitalizedLoanId
      finleyAccruedAmount
      created_at
      updated_at
      accountingAccount {
        id
        tAccount
        creditFacilityId
        organizationId
      }
    }
  }
  creditFacility {
    id
    name
  }
}
    `;
export const InvoiceDisbursementItemFragmentDocGQLType = gql`
    fragment InvoiceDisbursementItem on InvoiceDisbursementItem {
  id
  invoiceDisbursementId
  accountingAccountId
  accountingTransactionId
  amount
  serviceFeeAmount
  postServiceFeeTotalAmount
  created_at
  updated_at
  accountingAccount {
    id
    tAccount
    creditFacilityId
    organizationId
  }
}
    `;
export const InvoiceDisbursementFragmentDocGQLType = gql`
    fragment InvoiceDisbursement on InvoiceDisbursement {
  id
  invoiceId
  invoiceComponentId
  capitalProviderOrganizationId
  totalAmount
  autoSettle
  status
  dueDate
  paymentDate
  created_at
  updated_at
  invoiceDisbursementItems {
    ...InvoiceDisbursementItem
  }
  capitalProviderOrganization {
    id
    name
  }
  capitalProviderProRata
  serviceFeeTotals {
    serviceFeeAmount
    postServiceFeeTotalAmount
  }
}
    ${InvoiceDisbursementItemFragmentDocGQLType}`;
export const InvoicePaymentInKindItemFragmentDocGQLType = gql`
    fragment InvoicePaymentInKindItem on InvoicePaymentInKindItem {
  id
  invoiceId
  invoiceItemId
  capitalizedLenderShareId
  capitalizedLoanId
  totalAmount
  serviceFeeAmount
  postServiceFeeTotalAmount
  status
  dueDate
  notifiedDate
  created_at
  updated_at
  capitalProviderOrganization {
    id
    name
  }
  capitalProviderProRata
}
    `;
export const InvoiceConsolidatedDisbursementFragmentDocGQLType = gql`
    fragment InvoiceConsolidatedDisbursement on InvoiceConsolidatedDisbursement {
  id
  invoiceId
  capitalProviderOrganizationId
  totalCashDisbursementAmount
  totalCashServiceFeeAmount
  totalPostServiceFeeCashDisbursementAmount
  totalInterestCapitalizationAmount
  totalInterestCapitalizationServiceFeeAmount
  totalPostServiceFeeInterestCapitalizationAmount
  status
  paymentDate
  created_at
  updated_at
  capitalProviderOrganization {
    id
    name
  }
  capitalProviderProRataForFacility
}
    `;
export const GetInvoicesByOrganizationIdDocumentGQLType = gql`
    query GetInvoicesByOrganizationId($organizationId: UUID!) {
  getInvoicesByOrganizationId(organizationId: $organizationId) {
    ...InvoiceListItem
  }
}
    ${InvoiceListItemFragmentDocGQLType}`;

/**
 * __useGetInvoicesByOrganizationIdQuery__
 *
 * To run a query within a React component, call `useGetInvoicesByOrganizationIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetInvoicesByOrganizationIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetInvoicesByOrganizationIdQuery({
 *   variables: {
 *      organizationId: // value for 'organizationId'
 *   },
 * });
 */
export function useGetInvoicesByOrganizationIdQuery(baseOptions: Apollo.QueryHookOptions<GetInvoicesByOrganizationIdQueryGQLType, GetInvoicesByOrganizationIdQueryVariablesGQLType>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetInvoicesByOrganizationIdQueryGQLType, GetInvoicesByOrganizationIdQueryVariablesGQLType>(GetInvoicesByOrganizationIdDocumentGQLType, options);
      }
export function useGetInvoicesByOrganizationIdLazyQueryGQLType(baseOptions?: Apollo.LazyQueryHookOptions<GetInvoicesByOrganizationIdQueryGQLType, GetInvoicesByOrganizationIdQueryVariablesGQLType>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetInvoicesByOrganizationIdQueryGQLType, GetInvoicesByOrganizationIdQueryVariablesGQLType>(GetInvoicesByOrganizationIdDocumentGQLType, options);
        }
export type GetInvoicesByOrganizationIdQueryHookResult = ReturnType<typeof useGetInvoicesByOrganizationIdQuery>;
export type GetInvoicesByOrganizationIdLazyQueryGQLTypeHookResult = ReturnType<typeof useGetInvoicesByOrganizationIdLazyQueryGQLType>;
export type GetInvoicesByOrganizationIdQueryResultGQLType = Apollo.QueryResult<GetInvoicesByOrganizationIdQueryGQLType, GetInvoicesByOrganizationIdQueryVariablesGQLType>;
export const GetInvoicesByOrganizationIdPaginatedDocumentGQLType = gql`
    query GetInvoicesByOrganizationIdPaginated($organizationId: UUID!, $pagination: InvoicesPaginationInput!, $creditFacilityIds: [UUID!], $startDate: FullDateStr, $endDate: FullDateStr, $sortBy: InvoiceSortField, $sortDirection: SortDirection) {
  getInvoicesByOrganizationIdPaginated(
    organizationId: $organizationId
    pagination: $pagination
    creditFacilityIds: $creditFacilityIds
    startDate: $startDate
    endDate: $endDate
    sortBy: $sortBy
    sortDirection: $sortDirection
  ) {
    nodes {
      ...InvoiceListItem
    }
    totalCount
    pageInfo {
      hasNextPage
      hasPreviousPage
      startCursor
      endCursor
    }
  }
}
    ${InvoiceListItemFragmentDocGQLType}`;

/**
 * __useGetInvoicesByOrganizationIdPaginatedQuery__
 *
 * To run a query within a React component, call `useGetInvoicesByOrganizationIdPaginatedQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetInvoicesByOrganizationIdPaginatedQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetInvoicesByOrganizationIdPaginatedQuery({
 *   variables: {
 *      organizationId: // value for 'organizationId'
 *      pagination: // value for 'pagination'
 *      creditFacilityIds: // value for 'creditFacilityIds'
 *      startDate: // value for 'startDate'
 *      endDate: // value for 'endDate'
 *      sortBy: // value for 'sortBy'
 *      sortDirection: // value for 'sortDirection'
 *   },
 * });
 */
export function useGetInvoicesByOrganizationIdPaginatedQuery(baseOptions: Apollo.QueryHookOptions<GetInvoicesByOrganizationIdPaginatedQueryGQLType, GetInvoicesByOrganizationIdPaginatedQueryVariablesGQLType>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetInvoicesByOrganizationIdPaginatedQueryGQLType, GetInvoicesByOrganizationIdPaginatedQueryVariablesGQLType>(GetInvoicesByOrganizationIdPaginatedDocumentGQLType, options);
      }
export function useGetInvoicesByOrganizationIdPaginatedLazyQueryGQLType(baseOptions?: Apollo.LazyQueryHookOptions<GetInvoicesByOrganizationIdPaginatedQueryGQLType, GetInvoicesByOrganizationIdPaginatedQueryVariablesGQLType>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetInvoicesByOrganizationIdPaginatedQueryGQLType, GetInvoicesByOrganizationIdPaginatedQueryVariablesGQLType>(GetInvoicesByOrganizationIdPaginatedDocumentGQLType, options);
        }
export type GetInvoicesByOrganizationIdPaginatedQueryHookResult = ReturnType<typeof useGetInvoicesByOrganizationIdPaginatedQuery>;
export type GetInvoicesByOrganizationIdPaginatedLazyQueryGQLTypeHookResult = ReturnType<typeof useGetInvoicesByOrganizationIdPaginatedLazyQueryGQLType>;
export type GetInvoicesByOrganizationIdPaginatedQueryResultGQLType = Apollo.QueryResult<GetInvoicesByOrganizationIdPaginatedQueryGQLType, GetInvoicesByOrganizationIdPaginatedQueryVariablesGQLType>;
export const GetInvoiceAggregatesByOrganizationIdDocumentGQLType = gql`
    query GetInvoiceAggregatesByOrganizationId($organizationId: UUID!, $startDate: FullDateStr, $endDate: FullDateStr, $creditFacilityIds: [UUID!]) {
  getInvoiceAggregatesByOrganizationId(
    organizationId: $organizationId
    startDate: $startDate
    endDate: $endDate
    creditFacilityIds: $creditFacilityIds
  ) {
    dueSoon {
      status
      totalAmount
      count
    }
    overdue {
      status
      totalAmount
      count
    }
    paid {
      status
      totalAmount
      count
    }
    totalCount
  }
}
    `;

/**
 * __useGetInvoiceAggregatesByOrganizationIdQuery__
 *
 * To run a query within a React component, call `useGetInvoiceAggregatesByOrganizationIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetInvoiceAggregatesByOrganizationIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetInvoiceAggregatesByOrganizationIdQuery({
 *   variables: {
 *      organizationId: // value for 'organizationId'
 *      startDate: // value for 'startDate'
 *      endDate: // value for 'endDate'
 *      creditFacilityIds: // value for 'creditFacilityIds'
 *   },
 * });
 */
export function useGetInvoiceAggregatesByOrganizationIdQuery(baseOptions: Apollo.QueryHookOptions<GetInvoiceAggregatesByOrganizationIdQueryGQLType, GetInvoiceAggregatesByOrganizationIdQueryVariablesGQLType>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetInvoiceAggregatesByOrganizationIdQueryGQLType, GetInvoiceAggregatesByOrganizationIdQueryVariablesGQLType>(GetInvoiceAggregatesByOrganizationIdDocumentGQLType, options);
      }
export function useGetInvoiceAggregatesByOrganizationIdLazyQueryGQLType(baseOptions?: Apollo.LazyQueryHookOptions<GetInvoiceAggregatesByOrganizationIdQueryGQLType, GetInvoiceAggregatesByOrganizationIdQueryVariablesGQLType>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetInvoiceAggregatesByOrganizationIdQueryGQLType, GetInvoiceAggregatesByOrganizationIdQueryVariablesGQLType>(GetInvoiceAggregatesByOrganizationIdDocumentGQLType, options);
        }
export type GetInvoiceAggregatesByOrganizationIdQueryHookResult = ReturnType<typeof useGetInvoiceAggregatesByOrganizationIdQuery>;
export type GetInvoiceAggregatesByOrganizationIdLazyQueryGQLTypeHookResult = ReturnType<typeof useGetInvoiceAggregatesByOrganizationIdLazyQueryGQLType>;
export type GetInvoiceAggregatesByOrganizationIdQueryResultGQLType = Apollo.QueryResult<GetInvoiceAggregatesByOrganizationIdQueryGQLType, GetInvoiceAggregatesByOrganizationIdQueryVariablesGQLType>;
export const GetInvoicesByLoanIdDocumentGQLType = gql`
    query GetInvoicesByLoanId($loanId: UUID!) {
  invoices: getInvoicesByLoanId(loanId: $loanId) {
    ...InvoiceSummary
  }
}
    ${InvoiceSummaryFragmentDocGQLType}`;

/**
 * __useGetInvoicesByLoanIdQuery__
 *
 * To run a query within a React component, call `useGetInvoicesByLoanIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetInvoicesByLoanIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetInvoicesByLoanIdQuery({
 *   variables: {
 *      loanId: // value for 'loanId'
 *   },
 * });
 */
export function useGetInvoicesByLoanIdQuery(baseOptions: Apollo.QueryHookOptions<GetInvoicesByLoanIdQueryGQLType, GetInvoicesByLoanIdQueryVariablesGQLType>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetInvoicesByLoanIdQueryGQLType, GetInvoicesByLoanIdQueryVariablesGQLType>(GetInvoicesByLoanIdDocumentGQLType, options);
      }
export function useGetInvoicesByLoanIdLazyQueryGQLType(baseOptions?: Apollo.LazyQueryHookOptions<GetInvoicesByLoanIdQueryGQLType, GetInvoicesByLoanIdQueryVariablesGQLType>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetInvoicesByLoanIdQueryGQLType, GetInvoicesByLoanIdQueryVariablesGQLType>(GetInvoicesByLoanIdDocumentGQLType, options);
        }
export type GetInvoicesByLoanIdQueryHookResult = ReturnType<typeof useGetInvoicesByLoanIdQuery>;
export type GetInvoicesByLoanIdLazyQueryGQLTypeHookResult = ReturnType<typeof useGetInvoicesByLoanIdLazyQueryGQLType>;
export type GetInvoicesByLoanIdQueryResultGQLType = Apollo.QueryResult<GetInvoicesByLoanIdQueryGQLType, GetInvoicesByLoanIdQueryVariablesGQLType>;
export const GetInvoiceByIdDocumentGQLType = gql`
    query GetInvoiceById($invoiceId: UUID!) {
  getInvoiceById(invoiceId: $invoiceId) {
    ...Invoice
  }
}
    ${InvoiceFragmentDocGQLType}`;

/**
 * __useGetInvoiceByIdQuery__
 *
 * To run a query within a React component, call `useGetInvoiceByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetInvoiceByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetInvoiceByIdQuery({
 *   variables: {
 *      invoiceId: // value for 'invoiceId'
 *   },
 * });
 */
export function useGetInvoiceByIdQuery(baseOptions: Apollo.QueryHookOptions<GetInvoiceByIdQueryGQLType, GetInvoiceByIdQueryVariablesGQLType>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetInvoiceByIdQueryGQLType, GetInvoiceByIdQueryVariablesGQLType>(GetInvoiceByIdDocumentGQLType, options);
      }
export function useGetInvoiceByIdLazyQueryGQLType(baseOptions?: Apollo.LazyQueryHookOptions<GetInvoiceByIdQueryGQLType, GetInvoiceByIdQueryVariablesGQLType>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetInvoiceByIdQueryGQLType, GetInvoiceByIdQueryVariablesGQLType>(GetInvoiceByIdDocumentGQLType, options);
        }
export type GetInvoiceByIdQueryHookResult = ReturnType<typeof useGetInvoiceByIdQuery>;
export type GetInvoiceByIdLazyQueryGQLTypeHookResult = ReturnType<typeof useGetInvoiceByIdLazyQueryGQLType>;
export type GetInvoiceByIdQueryResultGQLType = Apollo.QueryResult<GetInvoiceByIdQueryGQLType, GetInvoiceByIdQueryVariablesGQLType>;
export const GetInvoiceDisbursementsByInvoiceIdDocumentGQLType = gql`
    query GetInvoiceDisbursementsByInvoiceId($invoiceId: UUID!) {
  getInvoiceDisbursementsByInvoiceId(invoiceId: $invoiceId) {
    ...InvoiceDisbursement
  }
}
    ${InvoiceDisbursementFragmentDocGQLType}`;

/**
 * __useGetInvoiceDisbursementsByInvoiceIdQuery__
 *
 * To run a query within a React component, call `useGetInvoiceDisbursementsByInvoiceIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetInvoiceDisbursementsByInvoiceIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetInvoiceDisbursementsByInvoiceIdQuery({
 *   variables: {
 *      invoiceId: // value for 'invoiceId'
 *   },
 * });
 */
export function useGetInvoiceDisbursementsByInvoiceIdQuery(baseOptions: Apollo.QueryHookOptions<GetInvoiceDisbursementsByInvoiceIdQueryGQLType, GetInvoiceDisbursementsByInvoiceIdQueryVariablesGQLType>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetInvoiceDisbursementsByInvoiceIdQueryGQLType, GetInvoiceDisbursementsByInvoiceIdQueryVariablesGQLType>(GetInvoiceDisbursementsByInvoiceIdDocumentGQLType, options);
      }
export function useGetInvoiceDisbursementsByInvoiceIdLazyQueryGQLType(baseOptions?: Apollo.LazyQueryHookOptions<GetInvoiceDisbursementsByInvoiceIdQueryGQLType, GetInvoiceDisbursementsByInvoiceIdQueryVariablesGQLType>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetInvoiceDisbursementsByInvoiceIdQueryGQLType, GetInvoiceDisbursementsByInvoiceIdQueryVariablesGQLType>(GetInvoiceDisbursementsByInvoiceIdDocumentGQLType, options);
        }
export type GetInvoiceDisbursementsByInvoiceIdQueryHookResult = ReturnType<typeof useGetInvoiceDisbursementsByInvoiceIdQuery>;
export type GetInvoiceDisbursementsByInvoiceIdLazyQueryGQLTypeHookResult = ReturnType<typeof useGetInvoiceDisbursementsByInvoiceIdLazyQueryGQLType>;
export type GetInvoiceDisbursementsByInvoiceIdQueryResultGQLType = Apollo.QueryResult<GetInvoiceDisbursementsByInvoiceIdQueryGQLType, GetInvoiceDisbursementsByInvoiceIdQueryVariablesGQLType>;
export const GetInvoiceDisbursementByIdDocumentGQLType = gql`
    query GetInvoiceDisbursementById($invoiceDisbursementId: UUID!) {
  getInvoiceDisbursementById(invoiceDisbursementId: $invoiceDisbursementId) {
    ...InvoiceDisbursement
  }
}
    ${InvoiceDisbursementFragmentDocGQLType}`;

/**
 * __useGetInvoiceDisbursementByIdQuery__
 *
 * To run a query within a React component, call `useGetInvoiceDisbursementByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetInvoiceDisbursementByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetInvoiceDisbursementByIdQuery({
 *   variables: {
 *      invoiceDisbursementId: // value for 'invoiceDisbursementId'
 *   },
 * });
 */
export function useGetInvoiceDisbursementByIdQuery(baseOptions: Apollo.QueryHookOptions<GetInvoiceDisbursementByIdQueryGQLType, GetInvoiceDisbursementByIdQueryVariablesGQLType>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetInvoiceDisbursementByIdQueryGQLType, GetInvoiceDisbursementByIdQueryVariablesGQLType>(GetInvoiceDisbursementByIdDocumentGQLType, options);
      }
export function useGetInvoiceDisbursementByIdLazyQueryGQLType(baseOptions?: Apollo.LazyQueryHookOptions<GetInvoiceDisbursementByIdQueryGQLType, GetInvoiceDisbursementByIdQueryVariablesGQLType>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetInvoiceDisbursementByIdQueryGQLType, GetInvoiceDisbursementByIdQueryVariablesGQLType>(GetInvoiceDisbursementByIdDocumentGQLType, options);
        }
export type GetInvoiceDisbursementByIdQueryHookResult = ReturnType<typeof useGetInvoiceDisbursementByIdQuery>;
export type GetInvoiceDisbursementByIdLazyQueryGQLTypeHookResult = ReturnType<typeof useGetInvoiceDisbursementByIdLazyQueryGQLType>;
export type GetInvoiceDisbursementByIdQueryResultGQLType = Apollo.QueryResult<GetInvoiceDisbursementByIdQueryGQLType, GetInvoiceDisbursementByIdQueryVariablesGQLType>;
export const GetInvoicePaymentInKindItemsByInvoiceIdDocumentGQLType = gql`
    query GetInvoicePaymentInKindItemsByInvoiceId($invoiceId: UUID!) {
  getInvoicePaymentInKindItemsByInvoiceId(invoiceId: $invoiceId) {
    invoiceItemId
    capitalizedLoanId
    capitalizedLoanName
    invoicePaymentInKindItems {
      ...InvoicePaymentInKindItem
    }
  }
}
    ${InvoicePaymentInKindItemFragmentDocGQLType}`;

/**
 * __useGetInvoicePaymentInKindItemsByInvoiceIdQuery__
 *
 * To run a query within a React component, call `useGetInvoicePaymentInKindItemsByInvoiceIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetInvoicePaymentInKindItemsByInvoiceIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetInvoicePaymentInKindItemsByInvoiceIdQuery({
 *   variables: {
 *      invoiceId: // value for 'invoiceId'
 *   },
 * });
 */
export function useGetInvoicePaymentInKindItemsByInvoiceIdQuery(baseOptions: Apollo.QueryHookOptions<GetInvoicePaymentInKindItemsByInvoiceIdQueryGQLType, GetInvoicePaymentInKindItemsByInvoiceIdQueryVariablesGQLType>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetInvoicePaymentInKindItemsByInvoiceIdQueryGQLType, GetInvoicePaymentInKindItemsByInvoiceIdQueryVariablesGQLType>(GetInvoicePaymentInKindItemsByInvoiceIdDocumentGQLType, options);
      }
export function useGetInvoicePaymentInKindItemsByInvoiceIdLazyQueryGQLType(baseOptions?: Apollo.LazyQueryHookOptions<GetInvoicePaymentInKindItemsByInvoiceIdQueryGQLType, GetInvoicePaymentInKindItemsByInvoiceIdQueryVariablesGQLType>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetInvoicePaymentInKindItemsByInvoiceIdQueryGQLType, GetInvoicePaymentInKindItemsByInvoiceIdQueryVariablesGQLType>(GetInvoicePaymentInKindItemsByInvoiceIdDocumentGQLType, options);
        }
export type GetInvoicePaymentInKindItemsByInvoiceIdQueryHookResult = ReturnType<typeof useGetInvoicePaymentInKindItemsByInvoiceIdQuery>;
export type GetInvoicePaymentInKindItemsByInvoiceIdLazyQueryGQLTypeHookResult = ReturnType<typeof useGetInvoicePaymentInKindItemsByInvoiceIdLazyQueryGQLType>;
export type GetInvoicePaymentInKindItemsByInvoiceIdQueryResultGQLType = Apollo.QueryResult<GetInvoicePaymentInKindItemsByInvoiceIdQueryGQLType, GetInvoicePaymentInKindItemsByInvoiceIdQueryVariablesGQLType>;
export const GetInvoicePaymentInKindItemByIdDocumentGQLType = gql`
    query GetInvoicePaymentInKindItemById($invoicePaymentInKindItemId: UUID!) {
  getInvoicePaymentInKindItemById(
    invoicePaymentInKindItemId: $invoicePaymentInKindItemId
  ) {
    ...InvoicePaymentInKindItem
  }
}
    ${InvoicePaymentInKindItemFragmentDocGQLType}`;

/**
 * __useGetInvoicePaymentInKindItemByIdQuery__
 *
 * To run a query within a React component, call `useGetInvoicePaymentInKindItemByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetInvoicePaymentInKindItemByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetInvoicePaymentInKindItemByIdQuery({
 *   variables: {
 *      invoicePaymentInKindItemId: // value for 'invoicePaymentInKindItemId'
 *   },
 * });
 */
export function useGetInvoicePaymentInKindItemByIdQuery(baseOptions: Apollo.QueryHookOptions<GetInvoicePaymentInKindItemByIdQueryGQLType, GetInvoicePaymentInKindItemByIdQueryVariablesGQLType>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetInvoicePaymentInKindItemByIdQueryGQLType, GetInvoicePaymentInKindItemByIdQueryVariablesGQLType>(GetInvoicePaymentInKindItemByIdDocumentGQLType, options);
      }
export function useGetInvoicePaymentInKindItemByIdLazyQueryGQLType(baseOptions?: Apollo.LazyQueryHookOptions<GetInvoicePaymentInKindItemByIdQueryGQLType, GetInvoicePaymentInKindItemByIdQueryVariablesGQLType>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetInvoicePaymentInKindItemByIdQueryGQLType, GetInvoicePaymentInKindItemByIdQueryVariablesGQLType>(GetInvoicePaymentInKindItemByIdDocumentGQLType, options);
        }
export type GetInvoicePaymentInKindItemByIdQueryHookResult = ReturnType<typeof useGetInvoicePaymentInKindItemByIdQuery>;
export type GetInvoicePaymentInKindItemByIdLazyQueryGQLTypeHookResult = ReturnType<typeof useGetInvoicePaymentInKindItemByIdLazyQueryGQLType>;
export type GetInvoicePaymentInKindItemByIdQueryResultGQLType = Apollo.QueryResult<GetInvoicePaymentInKindItemByIdQueryGQLType, GetInvoicePaymentInKindItemByIdQueryVariablesGQLType>;
export const GetInvoiceConsolidatedDisbursementsByInvoiceIdDocumentGQLType = gql`
    query GetInvoiceConsolidatedDisbursementsByInvoiceId($invoiceId: UUID!) {
  getInvoiceConsolidatedDisbursementsByInvoiceId(invoiceId: $invoiceId) {
    ...InvoiceConsolidatedDisbursement
  }
}
    ${InvoiceConsolidatedDisbursementFragmentDocGQLType}`;

/**
 * __useGetInvoiceConsolidatedDisbursementsByInvoiceIdQuery__
 *
 * To run a query within a React component, call `useGetInvoiceConsolidatedDisbursementsByInvoiceIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetInvoiceConsolidatedDisbursementsByInvoiceIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetInvoiceConsolidatedDisbursementsByInvoiceIdQuery({
 *   variables: {
 *      invoiceId: // value for 'invoiceId'
 *   },
 * });
 */
export function useGetInvoiceConsolidatedDisbursementsByInvoiceIdQuery(baseOptions: Apollo.QueryHookOptions<GetInvoiceConsolidatedDisbursementsByInvoiceIdQueryGQLType, GetInvoiceConsolidatedDisbursementsByInvoiceIdQueryVariablesGQLType>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetInvoiceConsolidatedDisbursementsByInvoiceIdQueryGQLType, GetInvoiceConsolidatedDisbursementsByInvoiceIdQueryVariablesGQLType>(GetInvoiceConsolidatedDisbursementsByInvoiceIdDocumentGQLType, options);
      }
export function useGetInvoiceConsolidatedDisbursementsByInvoiceIdLazyQueryGQLType(baseOptions?: Apollo.LazyQueryHookOptions<GetInvoiceConsolidatedDisbursementsByInvoiceIdQueryGQLType, GetInvoiceConsolidatedDisbursementsByInvoiceIdQueryVariablesGQLType>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetInvoiceConsolidatedDisbursementsByInvoiceIdQueryGQLType, GetInvoiceConsolidatedDisbursementsByInvoiceIdQueryVariablesGQLType>(GetInvoiceConsolidatedDisbursementsByInvoiceIdDocumentGQLType, options);
        }
export type GetInvoiceConsolidatedDisbursementsByInvoiceIdQueryHookResult = ReturnType<typeof useGetInvoiceConsolidatedDisbursementsByInvoiceIdQuery>;
export type GetInvoiceConsolidatedDisbursementsByInvoiceIdLazyQueryGQLTypeHookResult = ReturnType<typeof useGetInvoiceConsolidatedDisbursementsByInvoiceIdLazyQueryGQLType>;
export type GetInvoiceConsolidatedDisbursementsByInvoiceIdQueryResultGQLType = Apollo.QueryResult<GetInvoiceConsolidatedDisbursementsByInvoiceIdQueryGQLType, GetInvoiceConsolidatedDisbursementsByInvoiceIdQueryVariablesGQLType>;
export const GetLatestInvoiceFacilityFeeAccrualEndDateDocumentGQLType = gql`
    query GetLatestInvoiceFacilityFeeAccrualEndDate($creditFacilityId: UUID!) {
  getLatestInvoiceFacilityFeeAccrualEndDate(creditFacilityId: $creditFacilityId)
}
    `;

/**
 * __useGetLatestInvoiceFacilityFeeAccrualEndDateQuery__
 *
 * To run a query within a React component, call `useGetLatestInvoiceFacilityFeeAccrualEndDateQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetLatestInvoiceFacilityFeeAccrualEndDateQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetLatestInvoiceFacilityFeeAccrualEndDateQuery({
 *   variables: {
 *      creditFacilityId: // value for 'creditFacilityId'
 *   },
 * });
 */
export function useGetLatestInvoiceFacilityFeeAccrualEndDateQuery(baseOptions: Apollo.QueryHookOptions<GetLatestInvoiceFacilityFeeAccrualEndDateQueryGQLType, GetLatestInvoiceFacilityFeeAccrualEndDateQueryVariablesGQLType>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetLatestInvoiceFacilityFeeAccrualEndDateQueryGQLType, GetLatestInvoiceFacilityFeeAccrualEndDateQueryVariablesGQLType>(GetLatestInvoiceFacilityFeeAccrualEndDateDocumentGQLType, options);
      }
export function useGetLatestInvoiceFacilityFeeAccrualEndDateLazyQueryGQLType(baseOptions?: Apollo.LazyQueryHookOptions<GetLatestInvoiceFacilityFeeAccrualEndDateQueryGQLType, GetLatestInvoiceFacilityFeeAccrualEndDateQueryVariablesGQLType>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetLatestInvoiceFacilityFeeAccrualEndDateQueryGQLType, GetLatestInvoiceFacilityFeeAccrualEndDateQueryVariablesGQLType>(GetLatestInvoiceFacilityFeeAccrualEndDateDocumentGQLType, options);
        }
export type GetLatestInvoiceFacilityFeeAccrualEndDateQueryHookResult = ReturnType<typeof useGetLatestInvoiceFacilityFeeAccrualEndDateQuery>;
export type GetLatestInvoiceFacilityFeeAccrualEndDateLazyQueryGQLTypeHookResult = ReturnType<typeof useGetLatestInvoiceFacilityFeeAccrualEndDateLazyQueryGQLType>;
export type GetLatestInvoiceFacilityFeeAccrualEndDateQueryResultGQLType = Apollo.QueryResult<GetLatestInvoiceFacilityFeeAccrualEndDateQueryGQLType, GetLatestInvoiceFacilityFeeAccrualEndDateQueryVariablesGQLType>;
export const GetInvoiceConsolidatedDisbursementByIdDocumentGQLType = gql`
    query GetInvoiceConsolidatedDisbursementById($invoiceConsolidatedDisbursementId: UUID!) {
  getInvoiceConsolidatedDisbursementById(
    invoiceConsolidatedDisbursementId: $invoiceConsolidatedDisbursementId
  ) {
    ...InvoiceConsolidatedDisbursement
  }
}
    ${InvoiceConsolidatedDisbursementFragmentDocGQLType}`;

/**
 * __useGetInvoiceConsolidatedDisbursementByIdQuery__
 *
 * To run a query within a React component, call `useGetInvoiceConsolidatedDisbursementByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetInvoiceConsolidatedDisbursementByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetInvoiceConsolidatedDisbursementByIdQuery({
 *   variables: {
 *      invoiceConsolidatedDisbursementId: // value for 'invoiceConsolidatedDisbursementId'
 *   },
 * });
 */
export function useGetInvoiceConsolidatedDisbursementByIdQuery(baseOptions: Apollo.QueryHookOptions<GetInvoiceConsolidatedDisbursementByIdQueryGQLType, GetInvoiceConsolidatedDisbursementByIdQueryVariablesGQLType>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetInvoiceConsolidatedDisbursementByIdQueryGQLType, GetInvoiceConsolidatedDisbursementByIdQueryVariablesGQLType>(GetInvoiceConsolidatedDisbursementByIdDocumentGQLType, options);
      }
export function useGetInvoiceConsolidatedDisbursementByIdLazyQueryGQLType(baseOptions?: Apollo.LazyQueryHookOptions<GetInvoiceConsolidatedDisbursementByIdQueryGQLType, GetInvoiceConsolidatedDisbursementByIdQueryVariablesGQLType>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetInvoiceConsolidatedDisbursementByIdQueryGQLType, GetInvoiceConsolidatedDisbursementByIdQueryVariablesGQLType>(GetInvoiceConsolidatedDisbursementByIdDocumentGQLType, options);
        }
export type GetInvoiceConsolidatedDisbursementByIdQueryHookResult = ReturnType<typeof useGetInvoiceConsolidatedDisbursementByIdQuery>;
export type GetInvoiceConsolidatedDisbursementByIdLazyQueryGQLTypeHookResult = ReturnType<typeof useGetInvoiceConsolidatedDisbursementByIdLazyQueryGQLType>;
export type GetInvoiceConsolidatedDisbursementByIdQueryResultGQLType = Apollo.QueryResult<GetInvoiceConsolidatedDisbursementByIdQueryGQLType, GetInvoiceConsolidatedDisbursementByIdQueryVariablesGQLType>;
export const GetInvoiceFacilityFeeBalancesDocumentGQLType = gql`
    query GetInvoiceFacilityFeeBalances($creditFacilityId: UUID!, $startDate: FullDateStr!, $endDate: FullDateStr!) {
  getInvoiceFacilityFeeBalances(
    creditFacilityId: $creditFacilityId
    startDate: $startDate
    endDate: $endDate
  ) {
    account {
      id
      tAccount
      creditFacilityId
      organizationId
    }
    totalAccruedAmount
  }
}
    `;

/**
 * __useGetInvoiceFacilityFeeBalancesQuery__
 *
 * To run a query within a React component, call `useGetInvoiceFacilityFeeBalancesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetInvoiceFacilityFeeBalancesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetInvoiceFacilityFeeBalancesQuery({
 *   variables: {
 *      creditFacilityId: // value for 'creditFacilityId'
 *      startDate: // value for 'startDate'
 *      endDate: // value for 'endDate'
 *   },
 * });
 */
export function useGetInvoiceFacilityFeeBalancesQuery(baseOptions: Apollo.QueryHookOptions<GetInvoiceFacilityFeeBalancesQueryGQLType, GetInvoiceFacilityFeeBalancesQueryVariablesGQLType>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetInvoiceFacilityFeeBalancesQueryGQLType, GetInvoiceFacilityFeeBalancesQueryVariablesGQLType>(GetInvoiceFacilityFeeBalancesDocumentGQLType, options);
      }
export function useGetInvoiceFacilityFeeBalancesLazyQueryGQLType(baseOptions?: Apollo.LazyQueryHookOptions<GetInvoiceFacilityFeeBalancesQueryGQLType, GetInvoiceFacilityFeeBalancesQueryVariablesGQLType>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetInvoiceFacilityFeeBalancesQueryGQLType, GetInvoiceFacilityFeeBalancesQueryVariablesGQLType>(GetInvoiceFacilityFeeBalancesDocumentGQLType, options);
        }
export type GetInvoiceFacilityFeeBalancesQueryHookResult = ReturnType<typeof useGetInvoiceFacilityFeeBalancesQuery>;
export type GetInvoiceFacilityFeeBalancesLazyQueryGQLTypeHookResult = ReturnType<typeof useGetInvoiceFacilityFeeBalancesLazyQueryGQLType>;
export type GetInvoiceFacilityFeeBalancesQueryResultGQLType = Apollo.QueryResult<GetInvoiceFacilityFeeBalancesQueryGQLType, GetInvoiceFacilityFeeBalancesQueryVariablesGQLType>;
export const GetPrincipalPaymentMetricsByLoanIdDocumentGQLType = gql`
    query getPrincipalPaymentMetricsByLoanId($loanId: UUID!) {
  result: getPrincipalPaymentMetricsByLoanId(loanId: $loanId) {
    latestPaymentDate
    loanHasPayment
  }
}
    `;

/**
 * __useGetPrincipalPaymentMetricsByLoanIdQuery__
 *
 * To run a query within a React component, call `useGetPrincipalPaymentMetricsByLoanIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPrincipalPaymentMetricsByLoanIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPrincipalPaymentMetricsByLoanIdQuery({
 *   variables: {
 *      loanId: // value for 'loanId'
 *   },
 * });
 */
export function useGetPrincipalPaymentMetricsByLoanIdQuery(baseOptions: Apollo.QueryHookOptions<GetPrincipalPaymentMetricsByLoanIdQueryGQLType, GetPrincipalPaymentMetricsByLoanIdQueryVariablesGQLType>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPrincipalPaymentMetricsByLoanIdQueryGQLType, GetPrincipalPaymentMetricsByLoanIdQueryVariablesGQLType>(GetPrincipalPaymentMetricsByLoanIdDocumentGQLType, options);
      }
export function useGetPrincipalPaymentMetricsByLoanIdLazyQueryGQLType(baseOptions?: Apollo.LazyQueryHookOptions<GetPrincipalPaymentMetricsByLoanIdQueryGQLType, GetPrincipalPaymentMetricsByLoanIdQueryVariablesGQLType>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPrincipalPaymentMetricsByLoanIdQueryGQLType, GetPrincipalPaymentMetricsByLoanIdQueryVariablesGQLType>(GetPrincipalPaymentMetricsByLoanIdDocumentGQLType, options);
        }
export type GetPrincipalPaymentMetricsByLoanIdQueryHookResult = ReturnType<typeof useGetPrincipalPaymentMetricsByLoanIdQuery>;
export type GetPrincipalPaymentMetricsByLoanIdLazyQueryGQLTypeHookResult = ReturnType<typeof useGetPrincipalPaymentMetricsByLoanIdLazyQueryGQLType>;
export type GetPrincipalPaymentMetricsByLoanIdQueryResultGQLType = Apollo.QueryResult<GetPrincipalPaymentMetricsByLoanIdQueryGQLType, GetPrincipalPaymentMetricsByLoanIdQueryVariablesGQLType>;
export const GetLoanMetricsForInvoiceIdDocumentGQLType = gql`
    query getLoanMetricsForInvoiceId($invoiceId: UUID!) {
  result: getLoanMetricsForInvoiceId(invoiceId: $invoiceId) {
    latestFundTransferDate
    hasPrincipalPayment
  }
}
    `;

/**
 * __useGetLoanMetricsForInvoiceIdQuery__
 *
 * To run a query within a React component, call `useGetLoanMetricsForInvoiceIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetLoanMetricsForInvoiceIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetLoanMetricsForInvoiceIdQuery({
 *   variables: {
 *      invoiceId: // value for 'invoiceId'
 *   },
 * });
 */
export function useGetLoanMetricsForInvoiceIdQuery(baseOptions: Apollo.QueryHookOptions<GetLoanMetricsForInvoiceIdQueryGQLType, GetLoanMetricsForInvoiceIdQueryVariablesGQLType>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetLoanMetricsForInvoiceIdQueryGQLType, GetLoanMetricsForInvoiceIdQueryVariablesGQLType>(GetLoanMetricsForInvoiceIdDocumentGQLType, options);
      }
export function useGetLoanMetricsForInvoiceIdLazyQueryGQLType(baseOptions?: Apollo.LazyQueryHookOptions<GetLoanMetricsForInvoiceIdQueryGQLType, GetLoanMetricsForInvoiceIdQueryVariablesGQLType>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetLoanMetricsForInvoiceIdQueryGQLType, GetLoanMetricsForInvoiceIdQueryVariablesGQLType>(GetLoanMetricsForInvoiceIdDocumentGQLType, options);
        }
export type GetLoanMetricsForInvoiceIdQueryHookResult = ReturnType<typeof useGetLoanMetricsForInvoiceIdQuery>;
export type GetLoanMetricsForInvoiceIdLazyQueryGQLTypeHookResult = ReturnType<typeof useGetLoanMetricsForInvoiceIdLazyQueryGQLType>;
export type GetLoanMetricsForInvoiceIdQueryResultGQLType = Apollo.QueryResult<GetLoanMetricsForInvoiceIdQueryGQLType, GetLoanMetricsForInvoiceIdQueryVariablesGQLType>;
export const GetPaymentInKindServicingFeeDetailsForCreditFacilitiesDocumentGQLType = gql`
    query GetPaymentInKindServicingFeeDetailsForCreditFacilities($creditFacilityIds: [UUID!]!, $invoicePaymentStartDate: FullDateStr!, $invoicePaymentEndDate: FullDateStr!, $capitalizedLoanIds: [UUID!], $capitalProviderOrganizationIds: [UUID!]) {
  servicingFeeDetails: getPaymentInKindServicingFeeDetailsForCreditFacilities(
    creditFacilityIds: $creditFacilityIds
    invoicePaymentStartDate: $invoicePaymentStartDate
    invoicePaymentEndDate: $invoicePaymentEndDate
    capitalizedLoanIds: $capitalizedLoanIds
    capitalProviderOrganizationIds: $capitalProviderOrganizationIds
  ) {
    creditFacilityId
    creditFacilityName
    capitalProviderId
    capitalProviderName
    capitalizedLoanId
    capitalizedLoanName
    capitalizedExternalLoanId
    originatingLoanId
    originatingLoanName
    originatingExternalLoanId
    serviceFeeAmount
    invoicePaymentDate
    invoiceUpdatedAt
    runningBalance
    report {
      ...InvoiceReport
    }
  }
}
    ${InvoiceReportFragmentDocGQLType}`;

/**
 * __useGetPaymentInKindServicingFeeDetailsForCreditFacilitiesQuery__
 *
 * To run a query within a React component, call `useGetPaymentInKindServicingFeeDetailsForCreditFacilitiesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPaymentInKindServicingFeeDetailsForCreditFacilitiesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPaymentInKindServicingFeeDetailsForCreditFacilitiesQuery({
 *   variables: {
 *      creditFacilityIds: // value for 'creditFacilityIds'
 *      invoicePaymentStartDate: // value for 'invoicePaymentStartDate'
 *      invoicePaymentEndDate: // value for 'invoicePaymentEndDate'
 *      capitalizedLoanIds: // value for 'capitalizedLoanIds'
 *      capitalProviderOrganizationIds: // value for 'capitalProviderOrganizationIds'
 *   },
 * });
 */
export function useGetPaymentInKindServicingFeeDetailsForCreditFacilitiesQuery(baseOptions: Apollo.QueryHookOptions<GetPaymentInKindServicingFeeDetailsForCreditFacilitiesQueryGQLType, GetPaymentInKindServicingFeeDetailsForCreditFacilitiesQueryVariablesGQLType>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPaymentInKindServicingFeeDetailsForCreditFacilitiesQueryGQLType, GetPaymentInKindServicingFeeDetailsForCreditFacilitiesQueryVariablesGQLType>(GetPaymentInKindServicingFeeDetailsForCreditFacilitiesDocumentGQLType, options);
      }
export function useGetPaymentInKindServicingFeeDetailsForCreditFacilitiesLazyQueryGQLType(baseOptions?: Apollo.LazyQueryHookOptions<GetPaymentInKindServicingFeeDetailsForCreditFacilitiesQueryGQLType, GetPaymentInKindServicingFeeDetailsForCreditFacilitiesQueryVariablesGQLType>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPaymentInKindServicingFeeDetailsForCreditFacilitiesQueryGQLType, GetPaymentInKindServicingFeeDetailsForCreditFacilitiesQueryVariablesGQLType>(GetPaymentInKindServicingFeeDetailsForCreditFacilitiesDocumentGQLType, options);
        }
export type GetPaymentInKindServicingFeeDetailsForCreditFacilitiesQueryHookResult = ReturnType<typeof useGetPaymentInKindServicingFeeDetailsForCreditFacilitiesQuery>;
export type GetPaymentInKindServicingFeeDetailsForCreditFacilitiesLazyQueryGQLTypeHookResult = ReturnType<typeof useGetPaymentInKindServicingFeeDetailsForCreditFacilitiesLazyQueryGQLType>;
export type GetPaymentInKindServicingFeeDetailsForCreditFacilitiesQueryResultGQLType = Apollo.QueryResult<GetPaymentInKindServicingFeeDetailsForCreditFacilitiesQueryGQLType, GetPaymentInKindServicingFeeDetailsForCreditFacilitiesQueryVariablesGQLType>;
export const CreateInvoiceWithInvoiceItemsDocumentGQLType = gql`
    mutation CreateInvoiceWithInvoiceItems($invoice: InvoiceInput!, $invoiceComponentsWithInvoiceItems: [InvoiceComponentWithInvoiceItemsInput!]!) {
  createInvoiceWithInvoiceItems(
    invoice: $invoice
    invoiceComponentsWithInvoiceItems: $invoiceComponentsWithInvoiceItems
  ) {
    invoiceId
    invoiceWorkleaseId
    disbursementWorkleaseIds
  }
}
    `;
export type CreateInvoiceWithInvoiceItemsMutationFnGQLType = Apollo.MutationFunction<CreateInvoiceWithInvoiceItemsMutationGQLType, CreateInvoiceWithInvoiceItemsMutationVariablesGQLType>;

/**
 * __useCreateInvoiceWithInvoiceItemsMutation__
 *
 * To run a mutation, you first call `useCreateInvoiceWithInvoiceItemsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateInvoiceWithInvoiceItemsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createInvoiceWithInvoiceItemsMutation, { data, loading, error }] = useCreateInvoiceWithInvoiceItemsMutation({
 *   variables: {
 *      invoice: // value for 'invoice'
 *      invoiceComponentsWithInvoiceItems: // value for 'invoiceComponentsWithInvoiceItems'
 *   },
 * });
 */
export function useCreateInvoiceWithInvoiceItemsMutation(baseOptions?: Apollo.MutationHookOptions<CreateInvoiceWithInvoiceItemsMutationGQLType, CreateInvoiceWithInvoiceItemsMutationVariablesGQLType>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateInvoiceWithInvoiceItemsMutationGQLType, CreateInvoiceWithInvoiceItemsMutationVariablesGQLType>(CreateInvoiceWithInvoiceItemsDocumentGQLType, options);
      }
export type CreateInvoiceWithInvoiceItemsMutationHookResult = ReturnType<typeof useCreateInvoiceWithInvoiceItemsMutation>;
export type CreateInvoiceWithInvoiceItemsMutationResultGQLType = Apollo.MutationResult<CreateInvoiceWithInvoiceItemsMutationGQLType>;
export type CreateInvoiceWithInvoiceItemsMutationOptionsGQLType = Apollo.BaseMutationOptions<CreateInvoiceWithInvoiceItemsMutationGQLType, CreateInvoiceWithInvoiceItemsMutationVariablesGQLType>;
export const MarkInvoiceAsPaidDocumentGQLType = gql`
    mutation MarkInvoiceAsPaid($invoiceId: UUID!, $invoicePaymentDate: FullDateStr!) {
  markInvoiceAsPaid(
    invoiceId: $invoiceId
    invoicePaymentDate: $invoicePaymentDate
  ) {
    invoiceId
  }
}
    `;
export type MarkInvoiceAsPaidMutationFnGQLType = Apollo.MutationFunction<MarkInvoiceAsPaidMutationGQLType, MarkInvoiceAsPaidMutationVariablesGQLType>;

/**
 * __useMarkInvoiceAsPaidMutation__
 *
 * To run a mutation, you first call `useMarkInvoiceAsPaidMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMarkInvoiceAsPaidMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [markInvoiceAsPaidMutation, { data, loading, error }] = useMarkInvoiceAsPaidMutation({
 *   variables: {
 *      invoiceId: // value for 'invoiceId'
 *      invoicePaymentDate: // value for 'invoicePaymentDate'
 *   },
 * });
 */
export function useMarkInvoiceAsPaidMutation(baseOptions?: Apollo.MutationHookOptions<MarkInvoiceAsPaidMutationGQLType, MarkInvoiceAsPaidMutationVariablesGQLType>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<MarkInvoiceAsPaidMutationGQLType, MarkInvoiceAsPaidMutationVariablesGQLType>(MarkInvoiceAsPaidDocumentGQLType, options);
      }
export type MarkInvoiceAsPaidMutationHookResult = ReturnType<typeof useMarkInvoiceAsPaidMutation>;
export type MarkInvoiceAsPaidMutationResultGQLType = Apollo.MutationResult<MarkInvoiceAsPaidMutationGQLType>;
export type MarkInvoiceAsPaidMutationOptionsGQLType = Apollo.BaseMutationOptions<MarkInvoiceAsPaidMutationGQLType, MarkInvoiceAsPaidMutationVariablesGQLType>;
export const MarkInvoiceAsCanceledDocumentGQLType = gql`
    mutation MarkInvoiceAsCanceled($invoiceId: UUID!) {
  markInvoiceAsCanceled(invoiceId: $invoiceId) {
    invoiceId
  }
}
    `;
export type MarkInvoiceAsCanceledMutationFnGQLType = Apollo.MutationFunction<MarkInvoiceAsCanceledMutationGQLType, MarkInvoiceAsCanceledMutationVariablesGQLType>;

/**
 * __useMarkInvoiceAsCanceledMutation__
 *
 * To run a mutation, you first call `useMarkInvoiceAsCanceledMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMarkInvoiceAsCanceledMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [markInvoiceAsCanceledMutation, { data, loading, error }] = useMarkInvoiceAsCanceledMutation({
 *   variables: {
 *      invoiceId: // value for 'invoiceId'
 *   },
 * });
 */
export function useMarkInvoiceAsCanceledMutation(baseOptions?: Apollo.MutationHookOptions<MarkInvoiceAsCanceledMutationGQLType, MarkInvoiceAsCanceledMutationVariablesGQLType>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<MarkInvoiceAsCanceledMutationGQLType, MarkInvoiceAsCanceledMutationVariablesGQLType>(MarkInvoiceAsCanceledDocumentGQLType, options);
      }
export type MarkInvoiceAsCanceledMutationHookResult = ReturnType<typeof useMarkInvoiceAsCanceledMutation>;
export type MarkInvoiceAsCanceledMutationResultGQLType = Apollo.MutationResult<MarkInvoiceAsCanceledMutationGQLType>;
export type MarkInvoiceAsCanceledMutationOptionsGQLType = Apollo.BaseMutationOptions<MarkInvoiceAsCanceledMutationGQLType, MarkInvoiceAsCanceledMutationVariablesGQLType>;
export const MarkInvoiceDisbursementAsPaidDocumentGQLType = gql`
    mutation MarkInvoiceDisbursementAsPaid($invoiceDisbursementId: UUID!, $disbursementDate: FullDateStr!) {
  markInvoiceDisbursementAsPaid(
    invoiceDisbursementId: $invoiceDisbursementId
    disbursementDate: $disbursementDate
  ) {
    invoiceDisbursementId
  }
}
    `;
export type MarkInvoiceDisbursementAsPaidMutationFnGQLType = Apollo.MutationFunction<MarkInvoiceDisbursementAsPaidMutationGQLType, MarkInvoiceDisbursementAsPaidMutationVariablesGQLType>;

/**
 * __useMarkInvoiceDisbursementAsPaidMutation__
 *
 * To run a mutation, you first call `useMarkInvoiceDisbursementAsPaidMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMarkInvoiceDisbursementAsPaidMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [markInvoiceDisbursementAsPaidMutation, { data, loading, error }] = useMarkInvoiceDisbursementAsPaidMutation({
 *   variables: {
 *      invoiceDisbursementId: // value for 'invoiceDisbursementId'
 *      disbursementDate: // value for 'disbursementDate'
 *   },
 * });
 */
export function useMarkInvoiceDisbursementAsPaidMutation(baseOptions?: Apollo.MutationHookOptions<MarkInvoiceDisbursementAsPaidMutationGQLType, MarkInvoiceDisbursementAsPaidMutationVariablesGQLType>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<MarkInvoiceDisbursementAsPaidMutationGQLType, MarkInvoiceDisbursementAsPaidMutationVariablesGQLType>(MarkInvoiceDisbursementAsPaidDocumentGQLType, options);
      }
export type MarkInvoiceDisbursementAsPaidMutationHookResult = ReturnType<typeof useMarkInvoiceDisbursementAsPaidMutation>;
export type MarkInvoiceDisbursementAsPaidMutationResultGQLType = Apollo.MutationResult<MarkInvoiceDisbursementAsPaidMutationGQLType>;
export type MarkInvoiceDisbursementAsPaidMutationOptionsGQLType = Apollo.BaseMutationOptions<MarkInvoiceDisbursementAsPaidMutationGQLType, MarkInvoiceDisbursementAsPaidMutationVariablesGQLType>;
export const MarkInvoicePaymentInKindItemAsNotifiedDocumentGQLType = gql`
    mutation MarkInvoicePaymentInKindItemAsNotified($invoicePaymentInKindItemId: UUID!, $notifiedDate: FullDateStr!) {
  markInvoicePaymentInKindItemAsNotified(
    invoicePaymentInKindItemId: $invoicePaymentInKindItemId
    notifiedDate: $notifiedDate
  ) {
    invoicePaymentInKindItemId
  }
}
    `;
export type MarkInvoicePaymentInKindItemAsNotifiedMutationFnGQLType = Apollo.MutationFunction<MarkInvoicePaymentInKindItemAsNotifiedMutationGQLType, MarkInvoicePaymentInKindItemAsNotifiedMutationVariablesGQLType>;

/**
 * __useMarkInvoicePaymentInKindItemAsNotifiedMutation__
 *
 * To run a mutation, you first call `useMarkInvoicePaymentInKindItemAsNotifiedMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMarkInvoicePaymentInKindItemAsNotifiedMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [markInvoicePaymentInKindItemAsNotifiedMutation, { data, loading, error }] = useMarkInvoicePaymentInKindItemAsNotifiedMutation({
 *   variables: {
 *      invoicePaymentInKindItemId: // value for 'invoicePaymentInKindItemId'
 *      notifiedDate: // value for 'notifiedDate'
 *   },
 * });
 */
export function useMarkInvoicePaymentInKindItemAsNotifiedMutation(baseOptions?: Apollo.MutationHookOptions<MarkInvoicePaymentInKindItemAsNotifiedMutationGQLType, MarkInvoicePaymentInKindItemAsNotifiedMutationVariablesGQLType>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<MarkInvoicePaymentInKindItemAsNotifiedMutationGQLType, MarkInvoicePaymentInKindItemAsNotifiedMutationVariablesGQLType>(MarkInvoicePaymentInKindItemAsNotifiedDocumentGQLType, options);
      }
export type MarkInvoicePaymentInKindItemAsNotifiedMutationHookResult = ReturnType<typeof useMarkInvoicePaymentInKindItemAsNotifiedMutation>;
export type MarkInvoicePaymentInKindItemAsNotifiedMutationResultGQLType = Apollo.MutationResult<MarkInvoicePaymentInKindItemAsNotifiedMutationGQLType>;
export type MarkInvoicePaymentInKindItemAsNotifiedMutationOptionsGQLType = Apollo.BaseMutationOptions<MarkInvoicePaymentInKindItemAsNotifiedMutationGQLType, MarkInvoicePaymentInKindItemAsNotifiedMutationVariablesGQLType>;
export const UpdateInvoiceDueDateDocumentGQLType = gql`
    mutation UpdateInvoiceDueDate($invoiceId: UUID!, $newDueDate: FullDateStr!) {
  updateInvoiceDueDate(invoiceId: $invoiceId, newDueDate: $newDueDate) {
    invoiceId
  }
}
    `;
export type UpdateInvoiceDueDateMutationFnGQLType = Apollo.MutationFunction<UpdateInvoiceDueDateMutationGQLType, UpdateInvoiceDueDateMutationVariablesGQLType>;

/**
 * __useUpdateInvoiceDueDateMutation__
 *
 * To run a mutation, you first call `useUpdateInvoiceDueDateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateInvoiceDueDateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateInvoiceDueDateMutation, { data, loading, error }] = useUpdateInvoiceDueDateMutation({
 *   variables: {
 *      invoiceId: // value for 'invoiceId'
 *      newDueDate: // value for 'newDueDate'
 *   },
 * });
 */
export function useUpdateInvoiceDueDateMutation(baseOptions?: Apollo.MutationHookOptions<UpdateInvoiceDueDateMutationGQLType, UpdateInvoiceDueDateMutationVariablesGQLType>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateInvoiceDueDateMutationGQLType, UpdateInvoiceDueDateMutationVariablesGQLType>(UpdateInvoiceDueDateDocumentGQLType, options);
      }
export type UpdateInvoiceDueDateMutationHookResult = ReturnType<typeof useUpdateInvoiceDueDateMutation>;
export type UpdateInvoiceDueDateMutationResultGQLType = Apollo.MutationResult<UpdateInvoiceDueDateMutationGQLType>;
export type UpdateInvoiceDueDateMutationOptionsGQLType = Apollo.BaseMutationOptions<UpdateInvoiceDueDateMutationGQLType, UpdateInvoiceDueDateMutationVariablesGQLType>;
export const ReverseInvoicePaymentDocumentGQLType = gql`
    mutation ReverseInvoicePayment($invoiceId: UUID!) {
  reverseInvoicePayment(invoiceId: $invoiceId) {
    invoiceId
  }
}
    `;
export type ReverseInvoicePaymentMutationFnGQLType = Apollo.MutationFunction<ReverseInvoicePaymentMutationGQLType, ReverseInvoicePaymentMutationVariablesGQLType>;

/**
 * __useReverseInvoicePaymentMutation__
 *
 * To run a mutation, you first call `useReverseInvoicePaymentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useReverseInvoicePaymentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [reverseInvoicePaymentMutation, { data, loading, error }] = useReverseInvoicePaymentMutation({
 *   variables: {
 *      invoiceId: // value for 'invoiceId'
 *   },
 * });
 */
export function useReverseInvoicePaymentMutation(baseOptions?: Apollo.MutationHookOptions<ReverseInvoicePaymentMutationGQLType, ReverseInvoicePaymentMutationVariablesGQLType>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ReverseInvoicePaymentMutationGQLType, ReverseInvoicePaymentMutationVariablesGQLType>(ReverseInvoicePaymentDocumentGQLType, options);
      }
export type ReverseInvoicePaymentMutationHookResult = ReturnType<typeof useReverseInvoicePaymentMutation>;
export type ReverseInvoicePaymentMutationResultGQLType = Apollo.MutationResult<ReverseInvoicePaymentMutationGQLType>;
export type ReverseInvoicePaymentMutationOptionsGQLType = Apollo.BaseMutationOptions<ReverseInvoicePaymentMutationGQLType, ReverseInvoicePaymentMutationVariablesGQLType>;
export const MarkInvoiceConsolidatedDisbursementAsPaidDocumentGQLType = gql`
    mutation MarkInvoiceConsolidatedDisbursementAsPaid($invoiceConsolidatedDisbursementId: UUID!, $paymentDate: FullDateStr!) {
  markInvoiceConsolidatedDisbursementAsPaid(
    invoiceConsolidatedDisbursementId: $invoiceConsolidatedDisbursementId
    paymentDate: $paymentDate
  ) {
    invoiceConsolidatedDisbursementId
  }
}
    `;
export type MarkInvoiceConsolidatedDisbursementAsPaidMutationFnGQLType = Apollo.MutationFunction<MarkInvoiceConsolidatedDisbursementAsPaidMutationGQLType, MarkInvoiceConsolidatedDisbursementAsPaidMutationVariablesGQLType>;

/**
 * __useMarkInvoiceConsolidatedDisbursementAsPaidMutation__
 *
 * To run a mutation, you first call `useMarkInvoiceConsolidatedDisbursementAsPaidMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMarkInvoiceConsolidatedDisbursementAsPaidMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [markInvoiceConsolidatedDisbursementAsPaidMutation, { data, loading, error }] = useMarkInvoiceConsolidatedDisbursementAsPaidMutation({
 *   variables: {
 *      invoiceConsolidatedDisbursementId: // value for 'invoiceConsolidatedDisbursementId'
 *      paymentDate: // value for 'paymentDate'
 *   },
 * });
 */
export function useMarkInvoiceConsolidatedDisbursementAsPaidMutation(baseOptions?: Apollo.MutationHookOptions<MarkInvoiceConsolidatedDisbursementAsPaidMutationGQLType, MarkInvoiceConsolidatedDisbursementAsPaidMutationVariablesGQLType>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<MarkInvoiceConsolidatedDisbursementAsPaidMutationGQLType, MarkInvoiceConsolidatedDisbursementAsPaidMutationVariablesGQLType>(MarkInvoiceConsolidatedDisbursementAsPaidDocumentGQLType, options);
      }
export type MarkInvoiceConsolidatedDisbursementAsPaidMutationHookResult = ReturnType<typeof useMarkInvoiceConsolidatedDisbursementAsPaidMutation>;
export type MarkInvoiceConsolidatedDisbursementAsPaidMutationResultGQLType = Apollo.MutationResult<MarkInvoiceConsolidatedDisbursementAsPaidMutationGQLType>;
export type MarkInvoiceConsolidatedDisbursementAsPaidMutationOptionsGQLType = Apollo.BaseMutationOptions<MarkInvoiceConsolidatedDisbursementAsPaidMutationGQLType, MarkInvoiceConsolidatedDisbursementAsPaidMutationVariablesGQLType>;
export const UndoMarkInvoiceConsolidatedDisbursementAsPaidDocumentGQLType = gql`
    mutation UndoMarkInvoiceConsolidatedDisbursementAsPaid($invoiceConsolidatedDisbursementId: UUID!) {
  undoMarkInvoiceConsolidatedDisbursementAsPaid(
    invoiceConsolidatedDisbursementId: $invoiceConsolidatedDisbursementId
  ) {
    invoiceConsolidatedDisbursementId
  }
}
    `;
export type UndoMarkInvoiceConsolidatedDisbursementAsPaidMutationFnGQLType = Apollo.MutationFunction<UndoMarkInvoiceConsolidatedDisbursementAsPaidMutationGQLType, UndoMarkInvoiceConsolidatedDisbursementAsPaidMutationVariablesGQLType>;

/**
 * __useUndoMarkInvoiceConsolidatedDisbursementAsPaidMutation__
 *
 * To run a mutation, you first call `useUndoMarkInvoiceConsolidatedDisbursementAsPaidMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUndoMarkInvoiceConsolidatedDisbursementAsPaidMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [undoMarkInvoiceConsolidatedDisbursementAsPaidMutation, { data, loading, error }] = useUndoMarkInvoiceConsolidatedDisbursementAsPaidMutation({
 *   variables: {
 *      invoiceConsolidatedDisbursementId: // value for 'invoiceConsolidatedDisbursementId'
 *   },
 * });
 */
export function useUndoMarkInvoiceConsolidatedDisbursementAsPaidMutation(baseOptions?: Apollo.MutationHookOptions<UndoMarkInvoiceConsolidatedDisbursementAsPaidMutationGQLType, UndoMarkInvoiceConsolidatedDisbursementAsPaidMutationVariablesGQLType>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UndoMarkInvoiceConsolidatedDisbursementAsPaidMutationGQLType, UndoMarkInvoiceConsolidatedDisbursementAsPaidMutationVariablesGQLType>(UndoMarkInvoiceConsolidatedDisbursementAsPaidDocumentGQLType, options);
      }
export type UndoMarkInvoiceConsolidatedDisbursementAsPaidMutationHookResult = ReturnType<typeof useUndoMarkInvoiceConsolidatedDisbursementAsPaidMutation>;
export type UndoMarkInvoiceConsolidatedDisbursementAsPaidMutationResultGQLType = Apollo.MutationResult<UndoMarkInvoiceConsolidatedDisbursementAsPaidMutationGQLType>;
export type UndoMarkInvoiceConsolidatedDisbursementAsPaidMutationOptionsGQLType = Apollo.BaseMutationOptions<UndoMarkInvoiceConsolidatedDisbursementAsPaidMutationGQLType, UndoMarkInvoiceConsolidatedDisbursementAsPaidMutationVariablesGQLType>;